import { useEffect, useState } from 'react'
import { RouterProvider } from 'react-router-dom'

import { ThemeProvider } from '@mui/material/styles'
import { CssBaseline, StyledEngineProvider } from '@mui/material'

// routing
import router from 'routes'

// defaultTheme
import themes from 'themes'

// project imports
import NavigationScroll from 'layout/NavigationScroll'
import { LoadingProvider } from 'contexts/LoadingContext'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { UppyProvider } from 'contexts/UppyContext'
import { ConfirmDialogProvider } from 'contexts/ConfirmDialogContext'
import { serverThemeFake } from './themes/serverThemeFake'
// ==============================|| APP ||============================== //

const App = () => {
  const [theme, setTheme] = useState(null)
  useEffect(() => {
    const fetchTheme = async () => {
      try {
        const appTheme = themes(serverThemeFake)
        setTheme(appTheme)
      } catch (error) {
        console.error('Failed to fetch theme:', error)
        setTheme(themes())
      }
    }
    fetchTheme()
  }, [])
  if (!theme) return null
  return (
    <StyledEngineProvider injectFirst>
      <ConfirmDialogProvider>
        <LoadingProvider>
          <UppyProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <NavigationScroll>
                  <RouterProvider router={router} />
                </NavigationScroll>
              </ThemeProvider>
            </LocalizationProvider>
          </UppyProvider>
        </LoadingProvider>
      </ConfirmDialogProvider>
    </StyledEngineProvider>
  )
}

export default App
